var map = {
	"./MC-Logo-Color.png": 908,
	"./MC-Logo-Web-Color-StackedTagline.png": 909,
	"./MC-Logo-Web-White.png": 910,
	"./MC-Logo-White.png": 911,
	"./MC-Logo-combined.png": 912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;